export default "__VITE_ASSET__CG0N6fc4__"